import axios from 'axios';
import ReactPaginate from 'react-paginate'
import $ from 'jquery';
import React, { Component, useState } from 'react'
import Cookies from 'universal-cookie';
import swal from 'sweetalert';
import { ApiUrl } from '../../services/ApiRest';

import { Table, Button, Container, Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, ListGroupItemText, Alert } from 'reactstrap';
import "./hojaestilocalificaciontitul.css";

const urlListarTiposTitulacionHab = ApiUrl + "listartipotitulhabil" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";//
const urlListarCalifiTiposTitulacion = ApiUrl + "listarcalifitipotitul" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";//
const urlListaRolesAdm = ApiUrl + "listarolesadm" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlIngresarTipoCalificacion = ApiUrl + "ingtipocalificacion" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlListarTipoTitulacionCalif = ApiUrl + "listtipotitulasigcalif" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlModificarTipoCalificacion = ApiUrl + "modtipocalificacion" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";

const urlCambiarEstTipoCalif = ApiUrl + "actdesactipocalificacion" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";


const cookie = new Cookies();
let listaauxiliar = [];
const itemsPerPage = 10;
export default class ListTiposCalificaciones extends Component {

    constructor(props) {
        super(props)
        this.state = {
            listTiposTitulacion: [],//ok
            listroles: [],
            listTipoTitulacionCalif: [],

            //variables para paginacion
            currentItems: null,
            pageCount: 0,
            itemOffset: 0,
            count: 0,
        }
        this.handleChange = this.handleChange.bind(this);
        this.escFunction = this.escFunction.bind(this);
    }
    escFunction(event) {
        if (event.key === "Escape") {
            this.setState({ modalIngresarTipoCalificacion: false });
            this.setState({ modalModTipoCalificacion: false });
        }
    }
    handleChange = async (e) => {
        await this.setState({ [e.target.name]: e.target.value })
        this.setState({ estado: "" });

    }

    componentDidMount() {
        document.addEventListener("keydown", this.escFunction, true);
        //lista de los tipos de titulación con estado habilitado
        axios.get(urlListarTiposTitulacionHab)
            .then(response => {
                const listTiposTitulacion = response.data.data;
                this.setState({ listTiposTitulacion });
            })
        axios.get(urlListaRolesAdm)
            .then(response => {
                const listroles = response.data.data;

                this.setState({ listroles });
            })
    }


    filter = (event) => {
        const text = event.target.value.toLowerCase();

        if (text === "") {
            this.setState({
                currentItems: this.state.EstudianteBackup,
                textBuscar: text
            });
            return;
        }

        const data = this.state.estud;

        const newData = data.filter((item) => {
            const campo = `${item.nombre_calif_doc_titu} `.toLowerCase();
            return campo.includes(text);
        });

        this.setState({
            currentItems: newData,
            textBuscar: text
        });
    }

    //FUNCION DE PAGINACION POR  MEDIO DE UN CLIC
    handlePageClick = (event) => {

        const newOffset = (event.selected * itemsPerPage) % listaauxiliar.length;
        this.setState((state) => {
            return { itemOffset: newOffset }
        });
        const endOffset = newOffset + itemsPerPage;
        this.setState({ currentItems: listaauxiliar.slice(newOffset, endOffset) });
        this.setState({ EstudianteBackup: listaauxiliar.slice(newOffset, endOffset) });
        this.setState({ pageCount: Math.ceil(listaauxiliar.length / itemsPerPage) });
        this.setState((state) => {
            // Importante: lee state en vez de this.state al actualizar.
            return { itemOffset: newOffset }
        });
    }
    //FINDE FUNCION DE PAGINACION





    handleChangeTiposTitulacion = async (e) => {
        await this.setState({ [e.target.name]: e.target.value });
        axios.get(urlListarCalifiTiposTitulacion, {
            params: {
                idTipoTitulacionCalif: this.state.idTipoTitutacion
            }
        })

            .then(respuesta => {
                if (respuesta.data.success == true) {
                    listaauxiliar = respuesta.data.data;
                    const estud = respuesta.data.data;
                    this.setState((state) => {
                        return { estud: estud }
                    }
                    );
                    const EstudianteBackup = estud;
                    this.setState((state) => {
                        return { EstudianteBackup: EstudianteBackup }
                    });
                    //PAGINACION
                    this.setState({ itemOffset: 0 });
                    const endOffset = this.state.itemOffset + itemsPerPage;
                    this.setState({ currentItems: listaauxiliar.slice(this.state.itemOffset, endOffset) });
                    this.setState({ EstudianteBackup: listaauxiliar.slice(this.state.itemOffset, endOffset) });
                    this.setState({ pageCount: Math.ceil(listaauxiliar.length / itemsPerPage) });
                    this.setState((state) => {
                        return { itemOffset: state.itemOffset + endOffset }
                    });
                    //FIN  D DE LA PAGINACION
                } else {
                    this.setState({ error: "No existe estudiantes" });
                    swal({
                        text: "¡No existe información!",
                        icon: "info",
                        button: "Aceptar",
                    });
                    this.setState({ currentItems: [] });
                }
            })
    }
    //Modal de Ingreso
    mostrarModalIngresoTiposCalif = (registro) => {
        this.setState({ modalIngresarTipoCalificacion: true });
    }
    //Ocultar modal de ingreso
    ocultarModalIngresarTipoCalif = () => {
        this.setState({ modalIngresarTipoCalificacion: false });
    }

    ocultarModalModiftDatosTipoCalif = () => {
        this.setState({ modalModTipoCalificacion: false });
    }

    ingresarTipoCalificacion = () => {
        //Validaciones
        const errores = [];
        // Validar campo nombre
        if (!this.state.nombretipocalif || this.state.nombretipocalif.trim() === '') {
            errores.push("El campo 'Nombre' es obligatorio.");
        }
        // Validar selección de rol
        if (!this.state.idroltipocalifi || this.state.idroltipocalifi === "") {
            errores.push("Debe seleccionar un rol.");
        }
        // Mostrar errores si hay
        if (errores.length > 0) {
            swal({
                title: "Campos obligatorios faltantes",
                text: errores.join("\n"),
                icon: "warning",
                button: "Aceptar"
            });
            return;
        }


        // Recopilar los tipos de titulación seleccionados
        let tipotitulselect = [];
        $("input:checkbox[class=checkbox-califtipotitulacion]:checked").each(function () {
            const idTipoTitu = $(this).closest('tr').find('td').eq(0).text().trim();
            if (idTipoTitu) {
                tipotitulselect.push({ idTipoTitu });
            }
        });
        // Validación en frontend antes de enviar
        if (tipotitulselect.length === 0) {
            swal({
                text: "Debe seleccionar al menos un tipo de titulación.",
                icon: "warning",
                button: "Aceptar",
            });
            return;
        }

        if (!this.state.nombretipocalif || !this.state.idroltipocalifi || tipotitulselect.length === 0) {
            swal({
                title: "Faltan datos",
                text: "Por favor complete todos los campos obligatorios.",
                icon: "warning",
                button: "Aceptar"
            });
            return; // No continúa si falta información
        }

        // Preparar JSON a enviar
        const datos = {
            nomCalificacion: this.state.nombretipocalif,
            estadotc: 1,
            idRol: this.state.idroltipocalifi,
            listtipostitulacion: JSON.stringify(tipotitulselect),
        };

        // Enviar la solicitud
        axios.post(urlIngresarTipoCalificacion, datos)
            .then(response => {
                const res = response.data;
                if (response.status === 200 && res.success) {
                    swal({
                        text: "Datos procesados correctamente",
                        icon: "success",
                        button: "Aceptar",
                    });
                    // Recargar lista
                    axios.get(urlListarCalifiTiposTitulacion, {
                        params: {
                            idTipoTitulacionCalif: this.state.idTipoTitutacion
                        }
                    })
                        .then(respuesta => {

                            if (respuesta.data.success) {
                                const listaauxiliar = respuesta.data.data;
                                const endOffset = this.state.itemOffset + itemsPerPage;

                                this.setState({
                                    estud: listaauxiliar,
                                    EstudianteBackup: listaauxiliar,
                                    itemOffset: 0,
                                    currentItems: listaauxiliar.slice(0, endOffset),
                                    pageCount: Math.ceil(listaauxiliar.length / itemsPerPage),
                                    modalIngresarTipoCalificacion: false
                                });
                            } else {
                                swal({
                                    text: "¡No existe información!",
                                    icon: "info",
                                    button: "Aceptar",
                                });
                                this.setState({ currentItems: [], error: "No existe estudiantes" });
                            }
                        });

                } else {
                    swal({
                        text: res.message || "No se pudo guardar la información.",
                        icon: "error",
                        button: "Aceptar",
                    });
                }
            })
            .catch(error => {
                if (error.response && error.response.status === 400) {
                    // Mostramos los mensajes de validación de Laravel
                    const errores = error.response.data.errors;
                    let mensaje = '';
                    for (let campo in errores) {
                        mensaje += `${errores[campo].join(', ')}\n`;
                    }
                    swal({
                        title: "Campos inválidos",
                        text: mensaje,
                        icon: "warning",
                        button: "Aceptar"
                    });
                } else {
                    swal({
                        title: "Error de conexión",
                        text: "No se pudo conectar con el servidor.",
                        icon: "error",
                        button: "Aceptar"
                    });
                }
            });
    };

    //Modal de mostrar datos de un tipo de calificación
    mostrarModalDatosTipoCalificacion = (consola) => {
        $(function () {
            $("#idtipocalifmod").val(consola.id_calif_doc_titu);
            $("#nombretipocalifmod").val(consola.nombre_calif_doc_titu);
            $("#idroltipocalifimod").val(consola.rol_id);
        });
        this.setState({ idtipocalifmod: consola.id_calif_doc_titu });
        this.setState({ nombretipocalifmod: consola.nombre_calif_doc_titu });
        this.setState({ idroltipocalifimod: consola.rol_id });
        //Lista los tipos de titulación asignadas a una calificación
        axios.post(urlListarTipoTitulacionCalif, {
            idTipoCalif: consola.id_calif_doc_titu
        })
            .then(res => {
                var listTipoTitulacionCalif = res.data.data;
                this.setState({ listTipoTitulacionCalif });
            })
        this.setState({ modalModTipoCalificacion: true });
    }
    //modificar
    modificarTipoCalificacion = () => {

        //Crear la lista de roles seleccionados
        let tipotitulmodselect = [];
        // $("input[type=checkbox]:checked").each(function () {
        $("input:checkbox[class=checkbox-califtipotitulacionmod]:checked").each(function () {

            var tiposeleccionado = $(this).parent().parent().find('td').eq(0).text();
            let fila = {
                idTipoMod: tiposeleccionado
            };
            tipotitulmodselect.push(fila);
        });

        var gsontipootitulselect = JSON.stringify(tipotitulmodselect);

        axios
            .post(urlModificarTipoCalificacion, {
                idtipoCalificacion: this.state.idtipocalifmod,
                nombretcalif: this.state.nombretipocalifmod,
                idroltcalif: this.state.idroltipocalifimod,
                listtipotitumod: gsontipootitulselect,
            })
            .then(response => {
                if (response.data.success === true) {
                    swal({
                        text: "Datos procesados correctamente",
                        icon: "success",
                        button: "Aceptar",
                    });

                    axios.get(urlListarCalifiTiposTitulacion, {
                        params: {
                            idTipoTitulacionCalif: this.state.idTipoTitutacion
                        }
                    })

                        .then(respuesta => {
                            if (respuesta.data.success == true) {
                                listaauxiliar = respuesta.data.data;
                                const estud = respuesta.data.data;
                                this.setState((state) => {
                                    return { estud: estud }
                                }
                                );
                                const EstudianteBackup = estud;
                                this.setState((state) => {
                                    return { EstudianteBackup: EstudianteBackup }
                                });
                                //PAGINACION
                                this.setState({ itemOffset: 0 });
                                const endOffset = this.state.itemOffset + itemsPerPage;
                                this.setState({ currentItems: listaauxiliar.slice(this.state.itemOffset, endOffset) });
                                this.setState({ EstudianteBackup: listaauxiliar.slice(this.state.itemOffset, endOffset) });
                                this.setState({ pageCount: Math.ceil(listaauxiliar.length / itemsPerPage) });
                                this.setState((state) => {
                                    return { itemOffset: state.itemOffset + endOffset }
                                });
                                //FIN  D DE LA PAGINACION
                            } else {
                                this.setState({ error: "No existe estudiantes" });
                                swal({
                                    text: "¡No existe información!",
                                    icon: "info",
                                    button: "Aceptar",
                                });
                                this.setState({ currentItems: [] });
                            }
                        })

                    this.setState({ modalModTipoCalificacion: false });
                } else {
                    swal({
                        text: "Datos no actualizados",
                        icon: "error",
                        button: "Aceptar",
                    });
                    this.setState({ modalModTipoCalificacion: false });
                }
            })
            .catch(error => {

                this.setState({ error: "No existe conexión con el servidor" });
                swal({
                    text: "No existe conexión con el servidor",
                    icon: "error",
                    button: "Aceptar",

                });
            });
    }
    //Habilitar o deshabilitar el tipo de calificación	
    bttActDesac = (calificacion) => {
        // Cambia 1 -> 0, 0 -> 1
        const nuevoEstado = Number(calificacion.estado_tipo_calificacion) === 1 ? 0 : 1;

        axios.post(urlCambiarEstTipoCalif, {
            idTipoCalificacion: calificacion.id_calif_doc_titu,
            estado: nuevoEstado,
        })
            .then((response) => {
                if (response.status === 200 && response.data?.success) {
                   // swal({ text: "Estado actualizado correctamente", icon: "success", button: "Aceptar" });
                    // refrescar listado
                    return axios.get(urlListarCalifiTiposTitulacion, {
                        params: { idTipoTitulacionCalif: this.state.idTipoTitutacion ?? 'todos' }
                    });
                } else {
                    throw new Error(response.data?.message || "No se pudo actualizar el estado.");
                }
            })
            .then((respLista) => {
                if (respLista.data?.success) {
                    const lista = respLista.data.data;
                    const endOffset = 0 + itemsPerPage;
                    this.setState({
                        estud: lista,
                        EstudianteBackup: lista,
                        itemOffset: 0,
                        currentItems: lista.slice(0, endOffset),
                        pageCount: Math.ceil(lista.length / itemsPerPage),
                    });
                } else {
                    swal({ text: "¡No existe información!", icon: "info", button: "Aceptar" });
                    this.setState({ currentItems: [] });
                }
            })
            .catch((error) => {
                const msg = error.response?.data?.message || "No existe conexión con el servidor";
                swal({ text: msg, icon: "error", button: "Aceptar" });
            });
    };
    render() {
        return (

            <div className="row animate__animated animate__fadeIn">
                <ol className="breadcrumb mb-4">
                    <li className="breadcrumb-item active">{ }</li>
                </ol>
                <div className="card shadow p-3 mb-5 bg-white rounded">

                    <div className="back-istmas">
                        <i className="fa fa-clipboard-list bounce-custom fs-5"></i>
                        <b className="mb-0 fw-semibold"> Tipos de Calificaciones</b>
                    </div>


                    <div className="card-body">

                        <div className="row ">
                            <div className="col-12 col-sm-12 col-lg-5 col-xl-5 centrar" >
                                <div className="mb-3">
                                    <label className="form-label"><b> <i className="fa-magnifying-glass"></i> Buscar:</b></label>
                                    <input type="text" class="form-control col-md-12" value={this.state.text} placeholder="Buscar..." onChange={(text) => this.filter(text)} />

                                </div>
                            </div>
                            <div className="col-12 col-sm-12  col-lg-5 col-xl-5 centrar" >
                                <div className="mb-3">
                                    <label className="form-label"><b>Tipo de Titulación</b></label>
                                    <select className="form-select" id="idTipoTitutacion" name="idTipoTitutacion" value={this.state.value} onChange={this.handleChangeTiposTitulacion} aria-label="Default select example">
                                        <option value="undefined" selected="true" disabled>Seleccione un tipo de titulación</option>
                                        {this.state.listTiposTitulacion.map(tipotitul => <option key={tipotitul.id_tipo_titulacion} value={tipotitul.id_tipo_titulacion} > {tipotitul.nom_tipo_titulacion}</option>)}
                                        <option value="todos">Todos</option>
                                    </select>

                                </div>
                            </div>
                        </div>
                        <div className="row ">
                            <div className="col-12 col-sm-12 col-lg-6 col-xl-6 centrar" >
                                <div className="p-3 rounded-3 mt-3">
                                    <h6 className="fw-bold text-center mb-3 text-azul">Tipos de Calificaciones</h6>
                                    <div class="table-responsive">
                                        <table className="table table-hover table-sm-custom">
                                            <thead className="table-light">
                                                <tr className="text-start text-azul" >
                                                    <th scope="col">Nombre</th>
                                                    <th scope="col">Rol</th>
                                                    <th scope="col">Modificar</th>
                                                    <th scope="col">Estado</th>
                                                </tr>
                                            </thead>
                                            <tbody>

                                                {this.state.currentItems &&
                                                    this.state.currentItems.map((consola) => (
                                                        <tr className="text-start text-azul" class="list-afiliados" key={consola.id_calif_doc_titu}  >
                                                            <td class="oculto"> {consola.id_calif_doc_titu}</td>
                                                            <td >{consola.nombre_calif_doc_titu}</td>
                                                            <td>{consola.rol?.descripcion_rol || ''}</td>
                                                            <td className="text-center">
                                                                <button
                                                                    className="btn btn-link p-0"
                                                                    onClick={() => this.mostrarModalDatosTipoCalificacion(consola)}
                                                                    title="Ver/Editar"
                                                                >
                                                                    <i className="fas fa-pen text-azul bounce-custom"></i>
                                                                </button>
                                                            </td>
                                                            <td className="eliminar">
                                                                {(() => {
                                                                    switch (consola.estado_tipo_calificacion) {
                                                                        case 0:
                                                                            return (
                                                                                <button
                                                                                    className="badge bg-danger text-white px-2 py-1"
                                                                                    style={{ borderRadius: "10px", fontSize: "0.75rem", border: "none" }}
                                                                                    onClick={() => this.bttActDesac(consola)}
                                                                                >
                                                                                    Inactivo
                                                                                </button>
                                                                            );
                                                                        case 1:
                                                                            return (
                                                                                <button
                                                                                    className="badge bg-success text-white px-2 py-1"
                                                                                    style={{ borderRadius: "10px", fontSize: "0.75rem", border: "none" }}
                                                                                    onClick={() => this.bttActDesac(consola)}
                                                                                >
                                                                                    Activo
                                                                                </button>
                                                                            );
                                                                        default:
                                                                            return "";
                                                                    }
                                                                })()}
                                                            </td>
                                                        </tr>
                                                    ))}
                                            </tbody>
                                        </table>
                                        <Modal size='xs' isOpen={this.state.modalIngresarTipoCalificacion}>
                                            <ModalHeader>

                                                Ingresar un tipo de calificación
                                            </ModalHeader>
                                            <ModalBody class="colormodal" >
                                                <FormGroup>

                                                    <label className="form-label"><b>Nombre</b></label>
                                                    <input type="text" id="nombretipocalif" name="nombretipocalif" className="form-control" onChange={this.handleChange} required />
                                                    <label className="form-label"><b>Roles</b></label>
                                                    <select className="form-select" id="idroltipocalifi" name="idroltipocalifi" value={this.state.value} onChange={this.handleChange} aria-label="Default select example">
                                                        <option value="" disabled selected>Seleccione un rol</option>
                                                        {this.state.listroles.map(person => <option key={person.id_rol} value={person.id_rol} >{person.descripcion_rol}</option>)}

                                                    </select>
                                                    <br />
                                                    Seleccione el tipo de titulación

                                                    <div class="container">
                                                        <div class="row">

                                                            <div class="table-responsive">
                                                                <table id="tablacarreras" className="table  text-left" >
                                                                    <thead >
                                                                        <tr>
                                                                            <th scope="col">Tipo de titulación</th>
                                                                            <th scope="col">Seleccionar</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {this.state.listTiposTitulacion.map(consola => (
                                                                            <tr key={consola.id_tipo_titulacion}>
                                                                                <td class="oculto" >{consola.id_tipo_titulacion}</td>

                                                                                <td class="" >{consola.nom_tipo_titulacion}</td>
                                                                                <td class="">
                                                                                    <input disabled={(this.state.disablmodmat) ? "disabled" : ""} name={"checktipot" + consola.id_tipo_titulacion} id={"checktipot" + consola.id_tipo_titulacion} type="checkbox" class="checkbox-califtipotitulacion" />
                                                                                    {(() => {
                                                                                        $('#checktipot' + consola.id_tipo_titulacion).checked = false;
                                                                                    })()}
                                                                                </td>
                                                                            </tr>
                                                                        ))}
                                                                    </tbody>
                                                                </table>
                                                            </div>


                                                        </div>
                                                    </div>

                                                </FormGroup>
                                            </ModalBody>
                                            <ModalFooter>
                                                <Button
                                                    color="primary"
                                                    onClick={() => this.ingresarTipoCalificacion()}
                                                >
                                                    Registrar
                                                </Button>
                                                <Button
                                                    color="secondary"
                                                    onClick={this.ocultarModalIngresarTipoCalif}
                                                >
                                                    Salir
                                                </Button>
                                            </ModalFooter>
                                        </Modal>

                                    </div>
                                </div>
                                <div className="d-flex justify-content-center mt-4 ">
                                    <ReactPaginate
                                        previousLabel="<"
                                        nextLabel=">"
                                        pageCount={this.state.pageCount}
                                        onPageChange={this.handlePageClick}
                                        containerClassName="pagination pagination-sm-custom"
                                        pageLinkClassName="page-link"
                                        previousClassName="page-item"
                                        previousLinkClassName="page-link"
                                        nextClassName="page-item"
                                        nextLinkClassName="page-link"
                                        activeClassName="active"
                                    />
                                </div>

                                <div className="text-center mt-3">
                                    <button
                                        id="agregar"
                                        type="button"
                                        className="btn btn-sm btn-primary fw-semibold px-3 py-1 shadow-sm"
                                        style={{ borderRadius: "8px", fontSize: "0.85rem" }}
                                        onClick={e =>
                                            this.mostrarModalIngresoTiposCalif(e)
                                        }
                                    >
                                        <i className="fas fa-plus me-1"></i>Registrar
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div className="row  ">
                            <div className="mb-3 ">


                                <Modal classname="modal-background" isOpen={this.state.modalModTipoCalificacion}>
                                    <ModalHeader>
                                        Modificar un tipo de calificación
                                    </ModalHeader>
                                    <ModalBody class="colormodal" >
                                        <FormGroup>
                                            <input type="hidden" id="idtipocalifmod" name="idtipocalifmod" className="form-control" onChange={this.handleChange} required />

                                            <label className="form-label"><b>Nombre</b></label>
                                            <input type="text" id="nombretipocalifmod" name="nombretipocalifmod" className="form-control" onChange={this.handleChange} required />
                                            <label className="form-label"><b>Roles</b></label>
                                            <select className="form-select" id="idroltipocalifimod" name="idroltipocalifimod" value={this.state.value} onChange={this.handleChange} aria-label="Default select example">
                                                <option value="undefined" disabled>Seleccione una carrera</option>
                                                {this.state.listroles.map(person => <option key={person.id_rol} value={person.id_rol} >{person.descripcion_rol}</option>)}
                                            </select>

                                            <br />
                                            Seleccione el tipo de titulación

                                            <div class="container">
                                                <div class="row">

                                                    <div class="table-responsive">
                                                        <table id="tablacarreras" className="table  text-left" >
                                                            <thead >
                                                                <tr>
                                                                    <th scope="col">Tipo de titulación</th>
                                                                    <th scope="col">Seleccionar</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {this.state.listTipoTitulacionCalif.map(consola => (
                                                                    <tr key={consola.id_tipo_titulacion}>
                                                                        <td class="oculto" >{consola.id_tipo_titulacion}</td>

                                                                        <td class="" >{consola.nom_tipo_titulacion}</td>
                                                                        <td class="selectTipoTitulMod">
                                                                            <input name={"checktipotitulcalifmod" + consola.id_tipo_titulacion} id={"checktipotitulcalifmod" + consola.id_tipo_titulacion} type="checkbox" class="checkbox-califtipotitulacionmod" />
                                                                            {(() => {

                                                                                if (this.state.modalModTipoCalificacion == true) {
                                                                                    if (consola.estado == 1) {
                                                                                        $(function () {
                                                                                            $('#checktipotitulcalifmod' + consola.id_tipo_titulacion)[0].checked = true;
                                                                                        })
                                                                                    }
                                                                                    else {
                                                                                        if (consola.estado == 0) {
                                                                                            $(function () {
                                                                                                $('#checktipotitulcalifmod' + consola.id_tipo_titulacion)[0].checked = false;
                                                                                            })
                                                                                        }

                                                                                    }
                                                                                }
                                                                            })()}

                                                                        </td>
                                                                    </tr>
                                                                ))}

                                                            </tbody>
                                                        </table>
                                                    </div>


                                                </div>
                                            </div>
                                        </FormGroup>
                                    </ModalBody>
                                    <ModalFooter>
                                        <Button color="primary" onClick={this.modificarTipoCalificacion}>
                                            Modificar
                                        </Button>
                                        <Button color="secondary" onClick={this.ocultarModalModiftDatosTipoCalif}>
                                            Salir
                                        </Button>
                                    </ModalFooter>
                                </Modal>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
